// extracted by mini-css-extract-plugin
export default {"modalBody":"NotificationsSettings_modalBody__HyLlS"};